var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import assignSchemaToAsset from '../../requests/service/assignSchemaToAsset';
import ServiceAssetSchemaModel from '../../models/ServiceAssetSchemaModel';
/**
 *
 */
var AssignSchemaToAssetCommand = /** @class */ (function (_super) {
    __extends(AssignSchemaToAssetCommand, _super);
    function AssignSchemaToAssetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data Object
     * @param organisationId string
     * @param schemaModel ServiceSchemaModel
     * @param assetModel AssetModel
     * @param serviceAssetSchemaCollection ServiceAssetSchemaCollection
     * @param intl
     * @return {*}
     */
    AssignSchemaToAssetCommand.prototype.execute = function (data, organisationId, schemaModel, assetModel, serviceAssetSchemaCollection, intl) {
        this.intl = intl;
        this.data = data;
        this.schemaModel = schemaModel;
        this.assetModel = assetModel;
        this.serviceAssetSchemaCollection = serviceAssetSchemaCollection;
        var promise = assignSchemaToAsset(schemaModel, assetModel, organisationId, data);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    AssignSchemaToAssetCommand.prototype.then = function (response) {
        this.serviceAssetSchemaCollection.add(new ServiceAssetSchemaModel(response));
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.to.asset.added' }, { schemaName: this.schemaModel.name, assetId: this.assetModel.id }), 'dark', true);
    };
    return AssignSchemaToAssetCommand;
}(Command));
export default AssignSchemaToAssetCommand;
